/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import Vuelidate from 'vuelidate'
import VueToasted from 'vue-toasted'
import Vue2Editor from 'vue2-editor'

import VCalendar from 'v-calendar'

import FullCalendar from '@fullcalendar/vue'; // Import FullCalendar component


import 'material-icons/iconfont/material-icons.scss'

import store from './store/index'

require('./bootstrap')
require('datatables.net')
require('datatables.net-bs4')

Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(Datetime)
Vue.use(Vuelidate)
Vue.use(Vue2Editor)

Vue.use(VCalendar, {
    componentPrefix: 'vc' // Use <vc-calendar /> instead of <v-calendar />
})

const moment = require('moment')
require('moment/locale/fr')
Vue.use(require('vue-moment'), {
    moment
})
Vue.use(VueToasted, {iconPack: 'material'})
Vue.prototype.$axios = window.axios
window.Vue = require('vue')

Vue.component('FullCalendar', FullCalendar);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 */

/**
 *  Reporting pages
 */
Vue.component(
    'DeadlinesCalendar',
    require('./app-subdomain/activity_management/activity/pages/DeadlinesCalendar.vue')
        .default
)
Vue.component(
    'DeadlinesFullCalendar',
    require('./app-subdomain/activity_management/activity/pages/DeadlinesFullCalendar.vue')
        .default
)
Vue.component(
    'PlannedTasksCalendar',
    require('./app-subdomain/activity_management/activity/pages/PlannedTasksCalendar.vue')
        .default
)
Vue.component(
    'PlannedTasksFullCalendar',
    require('./app-subdomain/activity_management/activity/pages/PlannedTasksFullCalendar.vue')
        .default
)
Vue.component(
    'TableVat',
    require('./app-subdomain/activity_management/activity/pages/tableVat.vue')
        .default
)
Vue.component(
    'TableIss',
    require('./app-subdomain/activity_management/activity/pages/tableIss.vue')
        .default
)
Vue.component(
    'TableDir',
    require('./app-subdomain/activity_management/activity/pages/tableDir.vue')
        .default
)
Vue.component(
    'TableOtherTax',
    require('./app-subdomain/activity_management/activity/pages/tableOtherTax.vue')
        .default
)
Vue.component(
    'TableKeeping',
    require('./app-subdomain/activity_management/activity/pages/tableKeeping.vue')
        .default
)
Vue.component(
    'TablePrp',
    require('./app-subdomain/activity_management/activity/pages/tablePrp.vue')
        .default
)
Vue.component(
    'TableOtherMissions',
    require('./app-subdomain/activity_management/activity/pages/tableOtherMissions.vue')
        .default
)
Vue.component(
    'TableBalance',
    require('./app-subdomain/activity_management/activity/pages/tableBalance.vue')
        .default
)
Vue.component(
    'TableSituations',
    require('./app-subdomain/activity_management/activity/pages/tableSituations.vue')
        .default
)
Vue.component(
    'DeadlinesToGenerate',
    require('./app-subdomain/dashboard/pages/control/deadlinesToGenerate.vue')
        .default
)
Vue.component(
    'ClientLogs',
    require('./app-subdomain/dashboard/pages/control/clientLogs.vue')
        .default
)
Vue.component(
    'TableChargeGlobal',
    require('./app-subdomain/dashboard/pages/charge/tableChargeGobal.vue')
        .default
)
Vue.component(
    'TableChargeCollaborator',
    require('./app-subdomain/dashboard/pages/charge/tableChargeCollaborator.vue')
        .default
)
Vue.component(
    'PivotChargeClient',
    require('./app-subdomain/dashboard/pages/charge/pivotChargeClient.vue')
        .default
)
Vue.component(
    'PivotChargeCollaborator',
    require('./app-subdomain/dashboard/pages/charge/pivotChargeCollaborator.vue')
        .default
)
Vue.component(
    'ChargeChart',
    require('./app-subdomain/dashboard/pages/charge/chargeChart.vue').default
)
Vue.component(
    'TableActions',
    require('./app-subdomain/activity_management/clients/pages/tableActions.vue')
        .default
)
Vue.component(
    'MissionsCard',
    require('./app-subdomain/activity_management/clients/pages/MissionsCard.vue')
        .default
)
Vue.component(
    'TableCac',
    require('./app-subdomain/activity_management/activity/pages/tableCac.vue')
        .default
)

/**
 * reporting components
 */
Vue.component(
    'ReportingVerticalMenu',
    require('./app-subdomain/activity_management/activity/components/common/verticalMenu.vue')
        .default
)
Vue.component(
    'GenerateDeadlines',
    require('./app-subdomain/activity_management/clients/components/generateDeadlines.vue')
        .default
)
Vue.component(
    'YearHandler',
    require('./app-subdomain/activity_management/activity/components/YearHandler.vue')
        .default
)
Vue.component(
    'MonthHandler',
    require('./app-subdomain/activity_management/activity/components/MonthHandler.vue')
        .default
)
Vue.component(
    'WeekHandler',
    require('./app-subdomain/activity_management/time-sheets/components/WeekHandler.vue')
        .default
)
Vue.component(
    'CheckDeadline',
    require('./app-subdomain/activity_management/activity/components/CheckDeadlineNew.vue')
        .default
)
Vue.component(
    'BadgeDate',
    require('./app-subdomain/activity_management/activity/components/badgeDate.vue')
        .default
)
Vue.component(
    'DeadlinesHandler',
    require('./app-subdomain/activity_management/activity/components/DeadlinesHandlerNew.vue')
        .default
)
Vue.component(
    'EndOfExercise',
    require('./app-subdomain/activity_management/activity/components/EndOfExerciseNew.vue')
        .default
)
Vue.component(
    'AppointmentHandler',
    require('./app-subdomain/activity_management/activity/components/appointmentHandler.vue')
        .default
)
Vue.component(
    'AppointmentForm',
    require('./app-subdomain/activity_management/activity/components/appointmentForm.vue')
        .default
)
Vue.component(
    'CommentsBlock',
    require('./app-subdomain/activity_management/activity/components/CommentsBlock.vue')
        .default
)
Vue.component(
    'CommentHandler',
    require('./app-subdomain/activity_management/activity/components/CommentHandler.vue')
        .default
)
Vue.component(
    'SelectDeadlineState',
    require('./app-subdomain/activity_management/activity/components/SelectDeadlineStateNew.vue')
        .default
)

/**
 * filters
 */
Vue.component(
    'SelectCollaborator',
    require('./app-subdomain/activity_management/activity/components/AccountingFirmUserSelectNew.vue')
        .default
)
Vue.component(
    'SelectCompany',
    require('./app-subdomain/activity_management/activity/components/SelectAccountingFirmCompanyNew.vue')
        .default
)
Vue.component(
    'SelectLegalForm',
    require('./app-subdomain/activity_management/activity/components/SelectLegalForm.vue')
        .default
)
Vue.component(
    'SelectEndOfExercise',
    require('./app-subdomain/activity_management/activity/components/SelectEndOfExerciseNew.vue')
        .default
)
Vue.component(
    'SelectRole',
    require('./app-subdomain/activity_management/activity/components/SelectRoleNew.vue')
        .default
)

Vue.component(
    'LegalFormFilter',
    require('./app-subdomain/activity_management/activity/components/LegalFormFilter.vue')
        .default
)
Vue.component(
    'ChargeDataFilter',
    require('./app-subdomain/activity_management/miscellaneous/components/organisation/ChargeDataFilter.vue')
        .default
)
Vue.component(
    'WeekDayDurations',
    require('./app-subdomain/activity_management/miscellaneous/components/organisation/WeekDayDurations.vue')
        .default
)
/**
 *  CRM pages
 */
Vue.component(
    'NewProspect',
    require('./app-subdomain/activity_management/crm/components/prospects/NewProspect.vue')
        .default
)
Vue.component(
    'ProspectsTable',
    require('./app-subdomain/activity_management/crm/components/prospects/ProspectsTable.vue')
        .default
)

/**
 *  Clients pages
 */
Vue.component(
    'ClientsVerticalMenu',
    require('./app-subdomain/activity_management/clients/pages/ClientsVerticalMenu.vue')
        .default
)
Vue.component(
    'ClientVerticalMenu',
    require('./app-subdomain/activity_management/clients/pages/ClientVerticalMenu.vue')
        .default
)

Vue.component(
    'NewClient',
    require('./app-subdomain/activity_management/clients/pages/NewClient.vue')
        .default
)
Vue.component(
    'TableClients',
    require('./app-subdomain/activity_management/clients/pages/tableClients.vue')
        .default
)
Vue.component(
    'CreateClientGroup',
    require('./app-subdomain/activity_management/clientGroups/pages/CreateClientGroup.vue')
        .default
)
Vue.component(
    'EditClientGroup',
    require('./app-subdomain/activity_management/clientGroups/pages/EditClientGroup.vue')
        .default
)
Vue.component(
    'TableClientGroups',
    require('./app-subdomain/activity_management/clientGroups/pages/tableClientGroups.vue')
        .default
)
Vue.component(
    'TableCadorClients',
    require('./app-subdomain/activity_management/clients/pages/tableCadorClients.vue')
        .default
)
Vue.component(
    'TableFees',
    require('./app-subdomain/activity_management/clients/pages/tableFees.vue')
        .default
)
Vue.component(
    'FeesImportationErrorsTable',
    require('./app-subdomain/activity_management/import/FeesImportationErrorsTable.vue')
        .default
)
Vue.component(
    'FeesDeleter',
    require('./app-subdomain/activity_management/import/FeesDeleter.vue')
        .default
)
Vue.component(
    'FeesImportedData',
    require('./app-subdomain/activity_management/import/FeesImportedData.vue')
        .default
)
Vue.component(
    'TableBudgets',
    require('./app-subdomain/activity_management/clients/pages/tableBudgets.vue')
        .default
)
Vue.component(
    'HistoryIndex',
    require('./app-subdomain/activity_management/clients/components/history/Index.vue')
        .default
)
Vue.component(
    'HistoryFooter',
    require('./app-subdomain/activity_management/clients/components/history/Footer.vue')
        .default
)
Vue.component(
    'TasksContainer',
    require('./app-subdomain/activity_management/clients/pages/tasksContainer.vue')
        .default
)
Vue.component(
    'TasksIndex',
    require('./app-subdomain/activity_management/clients/components/tasks/ClientTaskIndex.vue')
        .default
)
Vue.component(
    'TasksFooter',
    require('./app-subdomain/activity_management/clients/components/tasks/Footer.vue')
        .default
)
Vue.component(
    'ClientLegalForm',
    require('./app-subdomain/activity_management/clients/components/infos/LegalForm.vue')
        .default
)
Vue.component(
    'ClientInternalForm',
    require('./app-subdomain/activity_management/clients/components/infos/InternalForm.vue')
        .default
)
Vue.component(
    'ClientMissionsHandler',
    require('./app-subdomain/activity_management/clients/components/MissionsHandler.vue')
        .default
)
Vue.component(
    'TableAllDeadlines',
    require('./app-subdomain/activity_management/clients/pages/tableDeadlines.vue')
        .default
)

Vue.component(
    'ClientChiefs',
    require('./app-subdomain/activity_management/clients/components/chiefs/Chiefs.vue')
        .default
)
Vue.component(
    'ClientAuditors',
    require('./app-subdomain/activity_management/clients/components/auditors/Auditors.vue')
        .default
)
Vue.component(
    'ClientAssociates',
    require('./app-subdomain/activity_management/clients/components/associates/Associates.vue')
        .default
)
Vue.component(
    'TaxationForm',
    require('./app-subdomain/activity_management/clients/components/taxation/TaxationForm.vue')
        .default
)
Vue.component(
    'Pappers',
    require('./app-subdomain/activity_management/clients/components/PappersForm.vue')
        .default
)
Vue.component(
    'ContactsTable',
    require('./app-subdomain/activity_management/clients/components/contacts/ContactsTable.vue')
        .default
)

Vue.component(
    'TablePendingImported',
    require('./app-subdomain/activity_management/clients/components/pending/tableImported.vue')
        .default
)
Vue.component(
    'TablePendingSent',
    require('./app-subdomain/activity_management/clients/components/pending/tableSent.vue')
        .default
)
Vue.component(
    'TablePendingAnswered',
    require('./app-subdomain/activity_management/clients/components/pending/tableAnswered.vue')
        .default
)
Vue.component(
    'TablePendingSolved',
    require('./app-subdomain/activity_management/clients/components/pending/tableSolved.vue')
        .default
)

/**
 * clients components
 */
Vue.component(
    'DropMenuDeadline',
    require('./app-subdomain/activity_management/clients/components/dropMenuDeadline.vue')
        .default
)
Vue.component(
    'DropMenuAction',
    require('./app-subdomain/activity_management/clients/components/dropMenuAction.vue')
        .default
)
Vue.component(
    'DeletePendingPoint',
    require('./app-subdomain/activity_management/clients/components/pending/deletePoint.vue')
        .default
)
Vue.component(
    'DuplicatePendingPoint',
    require('./app-subdomain/activity_management/clients/components/pending/duplicatePoint.vue')
        .default
)
Vue.component(
    'SendPendingPoint',
    require('./app-subdomain/activity_management/clients/components/pending/sendPoint.vue')
        .default
)
Vue.component(
    'SolvePendingPoint',
    require('./app-subdomain/activity_management/clients/components/pending/solvePoint.vue')
        .default
)
Vue.component(
    'UnsolvePendingPoint',
    require('./app-subdomain/activity_management/clients/components/pending/unsolvePoint.vue')
        .default
)
Vue.component(
    'ChatPendingPoint',
    require('./app-subdomain/activity_management/clients/components/pending/Chat.vue')
        .default
)
Vue.component(
    'CommentCreate',
    require('./app-subdomain/activity_management/clients/components/pending/CommentCreate.vue')
        .default
)
Vue.component(
    'CommentEdit',
    require('./app-subdomain/activity_management/clients/components/pending/CommentEdit.vue')
        .default
)
Vue.component(
    'ClientNewToDos',
    require('./app-subdomain/activity_management/clients/components/home/NewToDos.vue')
        .default
)
Vue.component(
    'ClientNewComments',
    require('./app-subdomain/activity_management/clients/components/home/NewComments.vue')
        .default
)
Vue.component(
    'ClientNextDeadlines',
    require('./app-subdomain/activity_management/clients/components/home/NextDeadlines.vue')
        .default
)
Vue.component(
    'ClientDeadlinesCalendar',
    require('./app-subdomain/activity_management/clients/components/home/ClientDeadlinesCalendar.vue')
        .default
)
Vue.component(
    'ClientDeadlinesFullCalendar',
    require('./app-subdomain/activity_management/clients/components/home/ClientDeadlinesFullCalendar.vue')
        .default
)
// Vue.component('client-associates', require('./components/subdomain_app/clients/associates/Index').default);

/**
 *  To do pages
 */
Vue.component(
    'TableOwnTasks',
    require('./app-subdomain/activity_management/todo/pages/tableOwnTasks.vue')
        .default
)
Vue.component(
    'TableOwnDelegatedTasks',
    require('./app-subdomain/activity_management/todo/pages/tableOwnDelegatedTasks.vue')
        .default
)
Vue.component(
    'NewTask',
    require('./app-subdomain/activity_management/todo/pages/newTask.vue')
        .default
)

Vue.component(
    'TableOthersTasks',
    require('./app-subdomain/activity_management/todo/pages/tableOthersTasks.vue')
        .default
)
Vue.component(
    'TableOthersDelegatedTasks',
    require('./app-subdomain/activity_management/todo/pages/tableOthersDelegatedTasks.vue')
        .default
)

Vue.component(
    'TableBillableTasks',
    require('./app-subdomain/activity_management/todo/pages/tableBillableTasks.vue')
        .default
)
Vue.component(
    'TableBilledTasks',
    require('./app-subdomain/activity_management/todo/pages/tableBilledTasks.vue')
        .default
)

Vue.component(
    'TodoVerticalMenu',
    require('./app-subdomain/activity_management/todo/pages/VerticalMenu.vue')
        .default
)

/**
 *  Time sheets pages
 */
Vue.component(
    'TimeSheetsVerticalMenu',
    require('./app-subdomain/activity_management/time-sheets/components/VerticalMenu.vue')
        .default
)
Vue.component(
    'TimeSheetsInput',
    require('./app-subdomain/activity_management/time-sheets/components/TimeInput.vue')
        .default
)
Vue.component(
    'TimeSheetsAccountingFirmUserWeekReport',
    require('./app-subdomain/activity_management/time-sheets/components/AccountingFirmUserWeekReport.vue')
        .default
)
Vue.component(
    'TimeSheetsAccountingFirmUserYearReport',
    require('./app-subdomain/activity_management/time-sheets/components/AccountingFirmUserYearReport.vue')
        .default
)
Vue.component(
    'TimeSheetsClientYearReport',
    require('./app-subdomain/activity_management/time-sheets/components/ClientYearReport.vue')
        .default
)
Vue.component(
    'TimeSheetsAccountingFirmWeekReport',
    require('./app-subdomain/activity_management/time-sheets/pages/accoutingFirmWeekReport.vue')
        .default
)
Vue.component(
    'TimeSheetsAccountingFirmWeekChargeControl',
    require('./app-subdomain/activity_management/time-sheets/components/AccountingFirmWeekChargeControl.vue')
        .default
)
Vue.component(
    'TimeSheetsAccountingFirmUserChargeControl',
    require('./app-subdomain/activity_management/time-sheets/components/AccountingFirmUserChargeControl.vue')
        .default
)
Vue.component(
    'TimeSheetsAccountingFirmYearReport',
    require('./app-subdomain/activity_management/time-sheets/pages/accoutingFirmYearReport.vue')
        .default
)
Vue.component(
    'TimeSheetsPivotReport',
    require('./app-subdomain/activity_management/time-sheets/components/PivotReport.vue')
        .default
)

/**
 *  Dashboard pages
 */
Vue.component(
    'DashboardBalanceGlobal',
    require('./app-subdomain/dashboard/pages/balance/balanceGlobal.vue').default
)
Vue.component(
    'DashboardBalanceUser',
    require('./app-subdomain/dashboard/pages/balance/balanceUser.vue').default
)
Vue.component(
    'DashboardBalanceState',
    require('./app-subdomain/dashboard/pages/balance/balanceState.vue').default
)
Vue.component(
    'BalanceDashboardVerticalMenu',
    require('./app-subdomain/dashboard/pages/balance/VerticalMenu.vue').default
)

Vue.component(
    'DashboardBudgetForecastCompany',
    require('./app-subdomain/dashboard/pages/budget/budgetForecastCompany.vue')
        .default
)
Vue.component(
    'DashboardBudgetForecastActivity',
    require('./app-subdomain/dashboard/pages/budget/budgetForecastActivity.vue')
        .default
)
Vue.component(
    'DashboardBudgetForecastClient',
    require('./app-subdomain/dashboard/pages/budget/budgetForecastClient.vue')
        .default
)
Vue.component(
    'DashboardBudgetRollingCompany',
    require('./app-subdomain/dashboard/pages/budget/budgetRollingCompany.vue')
        .default
)
Vue.component(
    'DashboardBudgetRollingActivity',
    require('./app-subdomain/dashboard/pages/budget/budgetRollingActivity.vue')
        .default
)
Vue.component(
    'DashboardBudgetRollingClient',
    require('./app-subdomain/dashboard/pages/budget/budgetRollingClient.vue')
        .default
)
Vue.component(
    'DashboardBudgetRollingInteractive',
    require('./app-subdomain/dashboard/pages/budget/budgetRollingInteractive.vue')
        .default
)
Vue.component(
    'DashboardBudgetRollingPivot',
    require('./app-subdomain/dashboard/pages/budget/budgetRollingPivot.vue')
        .default
)
Vue.component(
    'BudgetDashboardVerticalMenu',
    require('./app-subdomain/dashboard/pages/budget/VerticalMenu.vue').default
)

Vue.component(
    'DashboardFeesInteractive',
    require('./app-subdomain/dashboard/pages/fees/feesInteractive.vue').default
)
Vue.component(
    'DashboardFeesSynthesisTable',
    require('./app-subdomain/dashboard/pages/fees/FeesSynthesisTable.vue').default
)
Vue.component(
    'DashboardFeesExportCa',
    require('./app-subdomain/dashboard/pages/fees/FeesExportCa.vue').default
)
Vue.component(
    'DashboardFeesPivot',
    require('./app-subdomain/dashboard/pages/fees/feesPivot.vue').default
)

Vue.component(
    'DashboardEvolutionInteractive',
    require('./app-subdomain/dashboard/pages/fees/evolutionInteractive.vue')
        .default
)
Vue.component(
    'DashboardEvolutionPivotClient',
    require('./app-subdomain/dashboard/pages/fees/evolutionPivotClient.vue')
        .default
)
Vue.component(
    'DashboardEvolutionPivotFirm',
    require('./app-subdomain/dashboard/pages/fees/evolutionPivotFirm.vue')
        .default
)

Vue.component(
    'DashboardBilledVsRealFilterable',
    require('./app-subdomain/dashboard/pages/fees/billedVsRealFilterable.vue')
        .default
)
Vue.component(
    'DashboardBilledVsRealInteractive',
    require('./app-subdomain/dashboard/pages/fees/billedVsRealInteractive.vue')
        .default
)
Vue.component(
    'DashboardBilledVsRealPivot',
    require('./app-subdomain/dashboard/pages/fees/billedVsRealPivot.vue')
        .default
)
Vue.component(
    'DashboardBilledVsRealExport',
    require('./app-subdomain/dashboard/pages/fees/BilledVsRealExport.vue')
        .default
)
Vue.component(
    'FeesDashboardVerticalMenu',
    require('./app-subdomain/dashboard/pages/fees/VerticalMenu.vue').default
)
Vue.component(
    'TimesheetsDashboardVerticalMenu',
    require('./app-subdomain/dashboard/pages/time-sheets/VerticalMenu.vue')
        .default
)

Vue.component(
    'DashboardVerticalMenu',
    require('./app-subdomain/dashboard/pages/VerticalMenu.vue').default
)
Vue.component(
    'DashboardCadorUpdate',
    require('./app-subdomain/dashboard/pages/fees/cadorUpdate.vue').default
)

/**
 *  Homes
 */
Vue.component(
    'DashboardHome',
    require('./app-subdomain/dashboard/pages/home.vue').default
)
Vue.component(
    'ImportationHome',
    require('./app-subdomain/activity_management/miscellaneous/pages/importation/home.vue')
        .default
)
Vue.component(
    'TodoBillingHome',
    require('./app-subdomain/activity_management/miscellaneous/pages/todo-billing/home.vue')
        .default
)

/**
 *  Legal pages
 */
// Vue.component('legal-vertical-menu', require('./app-subdomain/activity_management/legal/components/VerticalMenu').default);
// Vue.component('table-pvag', require('./app-subdomain/activity_management/legal/pages/tablePvag').default);
// Vue.component('pv-generator', require('./app-subdomain/activity_management/legal/pages/generator').default);

/**
 * common components
 */
Vue.component(
    'Loading',
    require('./app-subdomain/common/components/loading.vue').default
)
Vue.component(
    'DateHandler',
    require('./app-subdomain/common/components/DateHandlerNew.vue').default
)
Vue.component(
    'MonthChargeHandler',
    require('./app-subdomain/common/components/MonthChargeHandler.vue').default
)
Vue.component(
    'ClientNavigator',
    require('./app-subdomain/common/components/ClientNavigator.vue').default
)

/**
 * home components
 */
Vue.component('Init', require('./app-subdomain/common/mixins/Init.vue').default)
Vue.component(
    'HomeButtons',
    require('./app-subdomain/home/components/HomeButtons.vue').default
)
Vue.component(
    'HomeNewToDos',
    require('./app-subdomain/home/components/NewToDos.vue').default
)
Vue.component(
    'HomeNewComments',
    require('./app-subdomain/home/components/NewComments.vue').default
)
Vue.component(
    'HomeNewJdc',
    require('./app-subdomain/home/components/NewJdc.vue').default
)

Vue.component(
    'Logout',
    require('./app-subdomain/common/mixins/Logout.vue').default
)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store
})
